import { Toast } from "@/services/toast";
import { api } from "../../../services/api";
import { bonds } from "../../../services/apiVariables";
import {
    BONDS_ACTIONS,
    BONDS_NO_FILTER_ACTIONS,
    BONDS_POSITION_CREATE_ACTIONS,
    BONDS_POSITION_DETAIL_ACTIONS,
    BONDS_POSITION_PORTFOLIO_DETAILS_ACTIONS,
    BONDS_POSITION_PRICEBYDATE_ACTIONS,
    BONDS_SEARCH_CREATE_ACTIONS,
    BONDS_SEARCH_FILTER_DETAIL_ACTIONS,
    BONDS_SEARCH_FILTER_LIST_ACTIONS,
    FOLLOW_BOND_ACTION,
    FULLTEXT_ACTIONS,
    FULLTEXT_ACTIONS_INBONDS,
    GET_ALLBONDS_ACTIONS,
    GET_ISSUER_FIRST_LETTER_LIST,
    GET_ISSUER_HISTORY,
    GET_ISSUER_LIST_BY_CHAR_ACTIONS,
    GET_ISSUER_LIST_BY_FIRST_LETTER,
    SEARCHFILTER_RENAME_ACTIONS
} from "../../actionType/bonds";

export const getBonds = (body: any) => (dispatch: (arg: { type: string; payload: any }) => void) => {
    if (body?.params?.page_no !== 1) {
        dispatch({
            type: BONDS_ACTIONS.GET_BONDS_REQUEST,
            payload: { isBoandsLoader: true },
        });
    } else {
        dispatch({
            type: BONDS_ACTIONS.GET_BONDS_REQUEST,
            payload: { isBoandsLoader: true },
        });
    }

    return new Promise((resolve, reject) => {
        api({ ...bonds.get, body })
            .then((data: any) => {
                if (Array.isArray(data) && data.length > 0) {
                    dispatch({ type: BONDS_ACTIONS.GET_BONDS, payload: data[0] });
                    resolve(data);
                } else {

                    dispatch({ type: BONDS_ACTIONS.GET_BONDS, payload: data });
                    resolve(data);
                }
            })
            .catch((error) => {
                //console.log("----error----->", error);
                dispatch({ type: BONDS_ACTIONS.GET_BONDS_ERROR, payload: error });
                reject(error);
            });
    });
};
export const getNoFilterBonds =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: BONDS_NO_FILTER_ACTIONS.GET_BONDS_NO_FILTER_REQUEST,
            payload: { isBoandsLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...bonds.get, body }).then((data: any) => {
                console.log('data getNoFilterBonds', data);


                dispatch({ type: BONDS_NO_FILTER_ACTIONS.GET_BONDS_NO_FILTER, payload: data });
                resolve(data);

            })
                .catch((error) => {
                    console.log("----error----->", error);
                    dispatch({ type: BONDS_NO_FILTER_ACTIONS.GET_BONDS_NO_FILTER_ERROR, payload: error });
                    reject(error);
                });
        });
    };
export const getFulltextHandle = (handleFullText: any, trigger: any) => (dispatch: (arg0: { type: string; payload: any, trigger: any }) => void) => {
    console.log("trigger", trigger);

    dispatch({ type: FULLTEXT_ACTIONS_INBONDS.FULLTEXT_ACTIONS_INBONDS_REQUEST, payload: { isBoandsFullTextHandle: true }, trigger: trigger });
    return new Promise((resolve, reject) => {
        // Toast({ type: 'success', message: 'User Detail update successfully', title: 'success' });
        dispatch({ type: FULLTEXT_ACTIONS_INBONDS.FULLTEXT_ACTIONS_INBONDS_RESPONSE, payload: handleFullText, trigger: trigger });
        resolve(handleFullText)
    });
}
export const getFullText =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        console.log('body------------>', body?.params?.page_no)

        if (body?.params?.page_no !== 1) {
            dispatch({
                type: FULLTEXT_ACTIONS.FULLTEXT_REQUEST,
                payload: {},
            });
        } else {
            dispatch({
                type: FULLTEXT_ACTIONS.FULLTEXT_REQUEST,
                payload: {},
            });
        }

        return new Promise((resolve, reject) => {
            api({ ...bonds.getFullText, body })
                .then((data: any) => {
                    if (Array.isArray(data) && data.length > 0) {
                        dispatch({ type: FULLTEXT_ACTIONS.FULLTEXT_GET_RESPONSE, payload: data[0] });
                        resolve(data);
                    } else {
                        dispatch({ type: FULLTEXT_ACTIONS.FULLTEXT_GET_RESPONSE, payload: data });
                        resolve(data);
                    }
                })
                .catch((error) => {
                    console.log("----error----->", error);
                    dispatch({ type: FULLTEXT_ACTIONS.FULLTEXT_ERROR, payload: error });
                    reject(error);
                });
        });
    };

export const createBondsFilter =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: BONDS_SEARCH_CREATE_ACTIONS.BONDS_SEARCH_CREATE_REQUEST,
            payload: { isFollowBondLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...bonds.createSearchFilter, body })
                .then((data: any) => {
                    console.log("filter data-->", data);

                    if (data?.status === "Error") {
                        Toast({ type: 'danger', message: data?.message, title: 'success' });
                    } else {
                        Toast({ type: 'success', message: "Filter created successfully", title: 'success' });
                    }


                    dispatch({
                        type: BONDS_SEARCH_CREATE_ACTIONS.BONDS_SEARCH_CREATE_RESPONSE,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    console.log(error);

                    Toast({ type: 'danger', message: error?.message, title: 'success' });

                    dispatch({ type: BONDS_SEARCH_CREATE_ACTIONS.BONDS_SEARCH_CREATE_ERROR, payload: [] });
                    reject(error);
                });
        });
    };
export const renameFilter =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: SEARCHFILTER_RENAME_ACTIONS.SEARCHFILTER_RENAME_REQUEST,
            payload: { isRenameFilterLoader: true },
        });
        return new Promise((resolve, reject) => {
            let prefixUrl = `?search_filter_id=${body.search_filter_id}`
            api({ ...bonds.renameFilter, body, prefixUrl })
                .then((data: any) => {
                    console.log("filter data-->", data);

                    if (data?.status === "Error") {
                        Toast({ type: 'danger', message: data?.message, title: 'success' });
                    } else {
                        Toast({ type: 'success', message: "Filter renamed successfully", title: 'success' });
                    }


                    dispatch({
                        type: SEARCHFILTER_RENAME_ACTIONS.SEARCHFILTER_RENAME_RESPONSE,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    console.log(error);

                    Toast({ type: 'danger', message: error?.message, title: 'success' });

                    dispatch({ type: SEARCHFILTER_RENAME_ACTIONS.SEARCHFILTER_RENAME_ERROR, payload: [] });
                    reject(error);
                });
        });
    };
export const getfollowBond =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: FOLLOW_BOND_ACTION.FOLLOW_BOND__REQUEST,
            payload: { isFollowBondLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...bonds.followBond, body })
                .then((data: any) => {
                    console.log(data);

                    Toast({ type: 'success', message: data?.data?.active === true ? 'Bond Followed' : 'Bond Unfollowed', title: 'success' });
                    dispatch({
                        type: FOLLOW_BOND_ACTION.FOLLOW_BOND,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    Toast({ type: 'danger', message: error.message, title: error.status });
                    dispatch({ type: FOLLOW_BOND_ACTION.FOLLOW_BOND__ERROR, payload: [] });
                    reject(error);
                });
        });
    };



export const getBondsFilterDetails =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: BONDS_SEARCH_FILTER_DETAIL_ACTIONS.BONDS_SEARCH_FILTER_DETAIL_REQUEST,
            payload: { isSearchDetailListLoader: true },
        });
        let prefixUrl = `?search_filter_id=${body}`
        return new Promise((resolve, reject) => {
            api({ ...bonds.searchFilterDetails, body, prefixUrl })
                .then((data: any) => {
                    dispatch({
                        type: BONDS_SEARCH_FILTER_DETAIL_ACTIONS.BONDS_SEARCH_FILTER_DETAIL_RESPONSE,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({ type: BONDS_SEARCH_FILTER_DETAIL_ACTIONS.BONDS_SEARCH_FILTER_DETAIL_ERROR, payload: [] });
                    reject(error);
                });
        });
    };



export const getBondsFilterList =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: BONDS_SEARCH_FILTER_LIST_ACTIONS.BONDS_SEARCH_FILTER_LIST_REQUEST,
            payload: { isbondSearchFilterListLoader: true },
        });
        // let prefixUrl=`?search_filter_id=${body}`
        return new Promise((resolve, reject) => {
            api({ ...bonds.bondSearchFilterList, body })
                .then((data: any) => {
                    if (data.code === 200) {
                        console.log('dat------------getBondsFilterList', data.data[0])
                        dispatch({
                            type: BONDS_SEARCH_FILTER_LIST_ACTIONS.BONDS_SEARCH_FILTER_LIST_RESPONSE,
                            payload: data?.data[0],
                        });
                        resolve(data?.data[0]);
                    } else {
                        dispatch({
                            type: BONDS_SEARCH_FILTER_LIST_ACTIONS.BONDS_SEARCH_FILTER_LIST_RESPONSE,
                            payload: [],
                        });
                        resolve([]);
                    }
                })
                .catch((error) => {
                    dispatch({ type: BONDS_SEARCH_FILTER_LIST_ACTIONS.BONDS_SEARCH_FILTER_LIST_ERROR, payload: [] });
                    reject(error);
                });
        });
    };
export const getBondPositionBriefDetails =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: BONDS_POSITION_DETAIL_ACTIONS.BONDS_POSITION_DETAIL_REQUEST,
            payload: { isbondSearchFilterListLoader: true },
        });
        // let prefixUrl=`?search_filter_id=${body}`
        return new Promise((resolve, reject) => {
            console.log('body------------', body);

            api({ ...bonds.bondPosition, body })
                .then((data: any) => {
                    // console.log('dat------------',data)
                    dispatch({
                        type: BONDS_POSITION_DETAIL_ACTIONS.BONDS_POSITION_DETAIL_RESPONSE,
                        payload: data[0],
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({ type: BONDS_POSITION_DETAIL_ACTIONS.BONDS_POSITION_DETAIL_ERROR, payload: [] });
                    reject(error);
                });
        });
    };
export const createBondsPosition =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: BONDS_POSITION_CREATE_ACTIONS.BONDS_POSITION_CREATE_REQUEST,
            payload: { isFollowBondLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...bonds.createBondPosition, body })
                .then((data: any) => {
                    Toast({ type: 'success', message: 'Position created successfully', title: 'success' });
                    dispatch({
                        type: BONDS_POSITION_CREATE_ACTIONS.BONDS_POSITION_CREATE_RESPONSE,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({ type: BONDS_POSITION_CREATE_ACTIONS.BONDS_POSITION_CREATE_ERROR, payload: [] });
                    reject(error);
                });
        });
    };
export const getBondsPortfolioList =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: BONDS_POSITION_PORTFOLIO_DETAILS_ACTIONS.BONDS_POSITION_PORTFOLIO_DETAILS_REQUEST,
            payload: { isFollowBondLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...bonds.PositionPortfolioDetails, body })
                .then((data: any) => {
                    dispatch({
                        type: BONDS_POSITION_PORTFOLIO_DETAILS_ACTIONS.BONDS_POSITION_PORTFOLIO_DETAILS_RESPONSE,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({ type: BONDS_POSITION_PORTFOLIO_DETAILS_ACTIONS.BONDS_POSITION_PORTFOLIO_DETAILS_ERROR, payload: [] });
                    reject(error);
                });
        });
    };
export const createBondsPriceByDate =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: BONDS_POSITION_CREATE_ACTIONS.BONDS_POSITION_CREATE_REQUEST,
            payload: { isFollowBondLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...bonds.createBondPosition, body })
                .then((data: any) => {
                    dispatch({
                        type: BONDS_POSITION_CREATE_ACTIONS.BONDS_POSITION_CREATE_RESPONSE,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({ type: BONDS_POSITION_CREATE_ACTIONS.BONDS_POSITION_CREATE_ERROR, payload: [] });
                    reject(error);
                });
        });
    };
export const getBondsPriceByDate =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: BONDS_POSITION_PRICEBYDATE_ACTIONS.BONDS_POSITION_PRICEBYDATE_ACTIONS_REQUEST,
            payload: { isFollowBondLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...bonds.PositionPortfolioPriceByDate, body })
                .then((data: any) => {
                    dispatch({
                        type: BONDS_POSITION_PRICEBYDATE_ACTIONS.BONDS_POSITION_PRICEBYDATE_ACTIONS_RESPONSE,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({ type: BONDS_POSITION_PRICEBYDATE_ACTIONS.BONDS_POSITION_PRICEBYDATE_ACTIONS_ERROR, payload: [] });
                    reject(error);
                });
        });
    };
export const getAllBonds =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: GET_ALLBONDS_ACTIONS.GET_ALLBONDS_ACTIONS_REQUEST,
            payload: { isFollowBondLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...bonds.getAllBonds, body })
                .then((data: any) => {
                    dispatch({
                        type: GET_ALLBONDS_ACTIONS.GET_ALLBONDS_ACTIONS_RESPONSE,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({ type: GET_ALLBONDS_ACTIONS.GET_ALLBONDS_ACTIONS_ERROR, payload: [] });
                    reject(error);
                });
        });
    };
// export const getClientIp = () => (dispatch: (arg0: { type: string; payload: any }) => void) => {
//     dispatch({
//         type: GET_CLIENT_IP.GET_CLIENT_IP_REQUEST,
//         payload: { isclientIpLoading: true },
//     });
//     return new Promise((resolve, reject) => {
//         axios.get('https://geolocation-db.com/json/')
//             .then((data: any) => {
//                 dispatch({
//                     type: GET_CLIENT_IP.GET_CLIENT_IP_RESPONSE,
//                     payload: data.data,
//                 });
//                 resolve(data);
//             })
//             .catch((error) => {
//                 dispatch({ type: GET_CLIENT_IP.GET_CLIENT_IP_ERROR, payload: [] });
//                 reject(error);
//             });
//     });
// };
export const getIssuersFirstLetterList = () => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
        type: GET_ISSUER_FIRST_LETTER_LIST.GET_ISSUER_FIRST_LETTER_LIST_REQUEST,
        payload: { isIssuerFirstletterListLoader: true },
    });
    return new Promise((resolve, reject) => {
        api({ ...bonds.getIssuerFirstLetterList })
            .then((data: any) => {
                dispatch({
                    type: GET_ISSUER_FIRST_LETTER_LIST.GET_ISSUER_FIRST_LETTER_LIST_RESPONSE,
                    payload: data?.data,
                });
                resolve(data);
            })
            .catch((error) => {
                dispatch({ type: GET_ISSUER_FIRST_LETTER_LIST.GET_ISSUER_FIRST_LETTER_LIST_ERROR, payload: [] });
                reject(error);
            });
    });
};
export const getIssuersListByChar = (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
        type: GET_ISSUER_LIST_BY_CHAR_ACTIONS.GET_ISSUER_LIST_BY_CHAR_REQUEST,
        payload: { isIssuerListByCharLoader: true },
    });
    return new Promise((resolve, reject) => {
        const prefixUrl = `?issuer_char=${body.issuer_char}&issuer=${body.issuer || ''}&page_no=${body.page_no || 1}&per_page=${body.per_page || 20}`
        api({ ...bonds.getIssuerListByChar, body, prefixUrl })
            .then((data: any) => {
                dispatch({
                    type: GET_ISSUER_LIST_BY_CHAR_ACTIONS.GET_ISSUER_LIST_BY_CHAR_RESPONSE,
                    payload: data?.data,
                });
                resolve(data);
            })
            .catch((error) => {
                dispatch({
                    type: GET_ISSUER_LIST_BY_CHAR_ACTIONS.GET_ISSUER_LIST_BY_CHAR_ERROR,
                    payload: []
                });
                reject(error);
            });
    });
};
export const getIssuerListByFirstLetter = (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
        type: GET_ISSUER_LIST_BY_FIRST_LETTER.GET_ISSUER_LIST_BY_FIRST_LETTER_REQUEST,
        payload: { isIssueListLoader: true },
    });
    return new Promise((resolve, reject) => {
        api({ ...bonds.getIssuerList, body })
            .then((data: any) => {
                dispatch({
                    type: GET_ISSUER_LIST_BY_FIRST_LETTER.GET_ISSUER_LIST_BY_FIRST_LETTER_RESPONSE,
                    payload: data,
                });
                resolve(data);
            })
            .catch((error) => {
                dispatch({ type: GET_ISSUER_LIST_BY_FIRST_LETTER.GET_ISSUER_LIST_BY_FIRST_LETTER_ERROR, payload: [] });
                reject(error);
            });
    });
};

export const getIssuerHistory = (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
        type: GET_ISSUER_HISTORY.GET_ISSUER_HISTORY_REQUEST,
        payload: { isIssuerFirstletterListLoader: true },
    });
    return new Promise((resolve, reject) => {
        console.log(body);

        api({ ...bonds.getIssuerHistory, body })
            .then((data: any) => {
                dispatch({
                    type: GET_ISSUER_HISTORY.GET_ISSUER_HISTORY_RESPONSE,
                    payload: data?.data,
                });
                resolve(data);
            })
            .catch((error) => {
                dispatch({ type: GET_ISSUER_HISTORY.GET_ISSUER_HISTORY_ERROR, payload: [] });
                reject(error);
            });
    });
};
// Add this action to set initial bonds
export const setInitialBonds = (data: any) => ({
    type: "SET_INITIAL_BONDS",
    payload: data,
});